import { toast as toastManager } from "@/components/ui/toast"

// Mantém um aviso "Enviando" na tela enquanto o arquivo sobe; ele some ao terminar, com sucesso ou erro.
export async function withUploadingToast<T>(fileName: string, upload: () => Promise<T>) {
  const id = toastManager.add({ title: "Enviando", description: fileName, type: "loading", timeout: 0 })
  try {
    return await upload()
  } finally {
    toastManager.close(id)
  }
}

// Aviso com carregamento para operações de várias etapas: a descrição acompanha a etapa atual até `close`.
export function openProgressToast(title: string, description?: string) {
  const id = toastManager.add({ title, description, type: "loading", timeout: 0 })
  return {
    update: (nextDescription: string) => toastManager.update(id, { description: nextDescription }),
    close: () => toastManager.close(id),
  }
}
